export default __webpack_public_path__ + "static/media/5.47f31721.png";